import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class CoachingCoachSettingsAvailabilityController extends Controller {
  queryParams = ['calendarSyncError'];

  @tracked calendarSyncError: 'already_linked' | 'failed' | null = null;
}
